export default "__VITE_ASSET__0hQRX3el__"